import type { IBrandConfig } from './types';

const PROTECTIV_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'https://www.iv.lt/privatumo-politika',
  termsOfService: 'https://www.iv.lt/bendrosios-paslaugu-teikimo-salygos',
  vaultProject: 'protectiv',
  adaChat: false,
  accountDetails: true,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  darkwebDashboardCard: false,
  defaultBillingCategoryKey: 'privacy_breach',
  downloadsRecommended: false,
  copyRightText: 'UAB „Interneto vizija. All rights reserved.',
  hasCustomerServiceSupport: false,
  horizontalVaultDashboardCards: true,
  ssoRedirectURL: null,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Support page',
        href: 'https://pagalba.iv.lt/lt',
        icon: 'support-faq',
        customerSupport: false,
      },
    ],
    call: {
      active: false,
    },
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'info@iv.lt',
      customerSupport: true,
    },
  },
};

export default PROTECTIV_BRAND_CONFIG;
